import { ICellRendererAngularComp, INoRowsOverlayAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'checkbox-cell',
  template: `<input type="checkbox" [checked]="params.value" (change)="onChange($event)">`,
  styleUrls: ['./checkbox-cell.component.scss']
})
export class CheckboxCellComponent implements INoRowsOverlayAngularComp, ICellRendererAngularComp {

  @ViewChild('.checkbox', { static: true }) checkbox: ElementRef;

  public params: ICellRendererParams;

  constructor() { }

  agInit(params: ICellRendererParams): void {
    this.params = params;

    // check if row has property disabledCheck for disabling checkbox
    // if (!params.data.hasOwnProperty('disableCheck')) {
    //   this.params.data.disableCheck = false;
    // }

    // if (!params.data.hasOwnProperty('checked')) {
    //   this.params.data.checked = params.value || false;
    // }

    // console.log(params.colDef, params.data);
    // console.log('Check: ', params.data, params.value);
  }

  public onChange(event): void {
    if (this.params.data) {
      let input = this.params.data;
      const groupKey = this.params.colDef.field;
      if (groupKey.includes('group#')) {
        input = {
          companyId: this.params.data.companyId,
          key: this.params.data.key,
          groupKey
        };
      }
      // checkbox for PayrollExtra
      if (groupKey.includes('applicable') || groupKey.includes('combobox')) {
        input[groupKey] = event.currentTarget.checked;
      }
      this.params
        .context
        .componentParent
        .onGroupCellClick(input, event.currentTarget.checked);
    }
  }

  refresh(): boolean {
    return false;
  }

}
